import { createSelector } from "@reduxjs/toolkit";

import { VendorStateType } from "@ob/layouts/VendorOnboarding/types";

// eslint-disable-next-line import/prefer-default-export
export const selectNextRoute = createSelector(
  (state: { vendor: VendorStateType }) => state.vendor,
  (vendor): string => vendor.routes.nextRoute,
);
